import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./testimonials.css";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      link: "https://www.linkedin.com/in/uzairali19/",
      name: "Uzair Ali",
      role: "Web Developer. JavaScript | React | Redux. Improving open-source projects, one commit at a time.",
      test: "As a developer and a problem solver, I think Yousaf is a great collaborative partner to have. I met Yousaf in some basic javascript & react projects and since then he has drastically progressed in his understanding of the development process. he always has a professional environment and has good audio and video quality which makes it easier to communicate with him.",
    },
    {
      id: 2,
      link: "https://www.linkedin.com/",
      name: "Ehtisham Ali",
      role: "Full-stack developer | Technical Support Engineer at Microverse",
      test: "I have worked with Yousaf on many projects. He is very professional in his work and has very good communication skills and problem solving abilities. I highly recommend him.",
    },
    {
      id: 3,
      link: "https://www.linkedin.com/",
      name: "Muhammad Hassan",
      test: "I had the pleasure of working with Mian on several projects and was consistently impressed by their technical skills and attention to detail. Mian is a highly knowledgeable and dedicated developer who consistently delivers quality results on time and within budget. Their expertise in React Native and ability to collaborate effectively with cross-functional teams made them a valuable assets to our projects. I highly recommend Mian to anyone in need of a talented and reliable developer.",
    },
    {
      id: 4,
      link: "https://www.linkedin.com/in/isaicespedes/",
      name: "Isai Céspedes",
      role: "Full-Stack Web Developer. JavaScript | React | Redux.",
      test: "I mentored Yousaf some months ago, and I can say that he is one of those people that you love to work with. He was always interested in what I was trying to teach him, paying attention and always asking questions if something was not clear. When it comes to professional skills, he is really committed to work, always doing his best and going beyond the requirements of the project he's building.",
    },
    {
      id: 5,
      link: "https://www.linkedin.com/in/hamzaalitarar/",
      name: "Hamza Tarar",
      role: "Software Developer",
      test: "Throughout all our collaborations, Yousaf has always conducted himself politely and kindly. He comes across as someone that's always willing to help and puts the team ahead of himself. But beneath this, I see a strength and determination to distinguish himself. he's not only someone I highly recommend but is also someone I greatly respect.",
    },
  ];
  return (
    <section id="testmonials">
      <h5>Feedback from my peers</h5>
      <h2>Testimonials</h2>
      <Swiper
        className="container testimonials__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {testimonials.map((test) => (
          <SwiperSlide className="testimonial" key={test.id}>
            <div className="client__avatar">
              <a href={test.link}>
                <BsLinkedin />
              </a>
            </div>
            <h5 className="client__name">{test.name}</h5>
            <small className="client__review">{test.test}</small>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
